import React from 'react'
import { FlexView } from '../../../components/common'
import styled from 'styled-components'
import { BsClock, BsSpeedometer2 } from 'react-icons/bs'
import { PiRulerThin } from 'react-icons/pi'
import { GiSpeedometer } from 'react-icons/gi'
import { LiaDnaSolid } from 'react-icons/lia'
import { useTranslation } from 'react-i18next'
import { BsCalendar4Event, BsCalendar4 } from 'react-icons/bs'
import { GoAlert } from 'react-icons/go'
import { IoCloseCircleOutline } from 'react-icons/io5'

const InfoCard = styled(FlexView)`
    width: 240px;
    height: 92.5px;
    border: 2px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 16px;
    margin: 0 9px 9px 0;

    & .infoCardTitle {

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #303030;
    margin: 0
        
    }

    & .subTitle {

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 12px;
    
    text-align: justify;
    margin: 0;
    
    color: #777777;
            
    }

    & .value {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        text-align: justify;

        color: #000000;
        margin: 0 0 10px 0;
    }

`

const JobSummaryIndicator = ({ indicatorData, highlightData }) => {
    const { t } = useTranslation()
    return (
        <FlexView flexDirection='row' justifyContent="flex-start" alignItems="center" flexWrap="wrap" style={{ marginTop: '10px' }}>
            {indicatorData && indicatorData.map((indicator, index) => (
                <InfoCard key={index} alignItems="center" flexDirection='column' justifyContent="flex-start" fontSize="medium">
                    <FlexView width="90%" justifyContent="space-between" flexDirection="row" margin="7.5px 10px 0 10px">
                        <h6 className="infoCardTitle">{t(indicator.description)}</h6>
                        {indicator.description === 'PipesApplied' ?
                            <LiaDnaSolid color='#59CBE4' size='25px' />
                            : indicator.description === 'Duration' ?
                                <BsClock color='#59CBE4' size='25px' />
                                : indicator.description === 'Cumulative Length' ?
                                    <PiRulerThin color='#59CBE4' size='30px' />
                                    : indicator.description === 'Average Speed' ?
                                        <BsSpeedometer2 color='#59CBE4' size='25px' />
                                        :
                                        <GiSpeedometer color='#59CBE4' size='25px' />
                        }
                    </FlexView>
                    <FlexView width="90%" justifyContent="space-between" flexDirection="row" margin="0 10px">
                        <p className="subTitle">({indicator.unit})</p>
                    </FlexView>
                    <FlexView height="25px" width="90%" justifyContent="flex-end" flexDirection="row">
                        <p className="value">{indicator.value}</p>
                    </FlexView>
                </InfoCard>
            ))}
            {highlightData && highlightData.map((indicator, i) => (
                <>
                    {indicator.description === 'Number of Rejects' ?
                        null
                        :
                        <InfoCard key={i} alignItems="center" flexDirection='column' justifyContent="flex-start" fontSize="medium">
                            <FlexView width="90%" justifyContent="space-between" flexDirection="row" margin="7.5px 10px 0 10px">
                                <h6 className="infoCardTitle">{t(indicator.description)}</h6>
                                {
                                    indicator.description === 'Planned Stoppages' ?
                                        <BsCalendar4Event color='#59CBE4' size='22px' />
                                        : indicator.description === 'Unplanned Stoppages' ?
                                            <BsCalendar4 color='#59CBE4' size='22px' />
                                            : indicator.description === 'Number of Watchdog Alerts' ?
                                                <GoAlert color='#59CBE4' size='25px' />
                                                :
                                                <IoCloseCircleOutline color='#59CBE4' size='30px' />
                                }
                            </FlexView>
                            <FlexView width="90%" justifyContent="flex-end" flexDirection="row" margin="15px 10px 0px 10px">
                                <p className="value">{indicator.value}</p>
                                {/* <Button padding="4px 8px" fontSize="13px" backgroundColor="secondary" color="white"  >View</Button> */}
                            </FlexView>
                        </InfoCard>
                    }
                </>
            ))}

        </FlexView>
    )

}

export default JobSummaryIndicator